<template>
    <el-dialog
        title="新增车辆"
        top="8%"
        width="30%"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :custom-class="'performanceCreationDialog'"
    >
        <el-form
            :model="formData"
            :rules="rules"
            ref="form"
            label-width="120px"
        >
            <el-row>
                <el-col :span="22">
                    <el-form-item label="车牌号码：" prop="vehicleCard">
                        <el-input
                            v-model="formData.vehicleCard"
                            autocomplete="off"
                            placeholder="车牌号码"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="车型：" prop="equipmentName">
                        <el-input
                            v-model="formData.equipmentName"
                            :readonly="true"
                            autocomplete="off"
                            placeholder="车型"
                        >
                            <i
                                slot="suffix"
                                class="el-input__icon el-icon-circle-close"
                                v-if="formData.equipmentName"
                                @click="clearCarTypeNameCn"
                            ></i>
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                @click="openAdvanceDialog"
                            ></el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">保 存</el-button>
        </div>

        <advanceDialog
            ref="advanceDialog"
            v-model="formData.equipmentName"
            :mValue="formData.equipmentName"
            :params="carTypeNameCnConfig"
            @confirm="confirm"
        ></advanceDialog>
    </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import { carTypeNameCnConfig } from './config.js';
import { addVehicleCard } from '../../../api/vehicleCardManage.js';
export default {
    name: 'vehicleCardManageDialog',
    components: { advanceDialog },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        supplierCode: {
            type: String,
            default: ''
        }
    },
    data () {
        // 校验 车牌号 格式
        var validateVehicleCard = (rule, value, callback) => {
            const _carNoVerify = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
            if (!value) {
                callback(new Error('请输入车牌号码'));
            } else if (!_carNoVerify.test(value)) {
                callback(new Error('请输入正确的车牌号码'));
            } else {
                callback();
            }
        };
        return {
            carTypeNameCnConfig,
            rules: {
                equipmentName: [{ required: true, message: '请选择车型', trigger: ['change', 'blur'] }],
                vehicleCard: [{ validator: validateVehicleCard, required: true, trigger: ['change', 'blur'] }]
            },
            formData: {
                vehicleCard: '',
                equipmentName: '',
                equipmentType: '',
                supplierCode: ''
            },
        };
    },
    methods: {
        // 打开车型高级搜索 弹窗
        openAdvanceDialog () {
            this.$refs.advanceDialog.show(true, this.carTypeNameCnConfig, { supplierCode: this.supplierCode }, '', [], this.formData.equipmentName);
        },
        // 车型搜索框 清空的方法
        clearCarTypeNameCn () {
            this.formData.equipmentName = '';
            this.formData.equipmentType = ''
        },
        // 车型高级搜索 数据选中的回调
        confirm (data) {
            this.formData.equipmentName = data.lengthNameCn;
            this.formData.equipmentType = data.length
        },
        // 关闭弹窗
        handleClose () {
            this.$emit('handleVehicleCardDialogClose');
        },
        // 提交
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    addVehicleCard(this.formData).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('操作成功');
                            this.$emit('handleVehicleCardDialogClose');
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    },
    mounted () {
        this.formData.supplierCode = this.supplierCode;
    }
};
</script>
<style lang="less">
.performanceCreationDialog {
    .el-dialog__body {
        padding: 30px 50px 10px 0;
    }

    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
}

// .el-select {
//     width: 100%;
// }
</style>
